import { render } from "./AdminNewDiscount.vue?vue&type=template&id=65e8b75e"
import script from "./AdminNewDiscount.vue?vue&type=script&lang=js"
export * from "./AdminNewDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__